import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { underwritingQueueService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseQaClaimMutationProps = {
	id: string;
	onSuccessHandler?: Function;
};

const useQaClaimMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: UseQaClaimMutationProps) => {
			dispatch(uiActions.showSpinnerOverlay());

			return underwritingQueueService.claimToCurrentUserOnQaUw({
				id,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess(_data, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Claim has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useQaClaimMutation;
